import { Link } from "react-router-dom";
import type { Film } from "@/mocks/films";
import { getCategoryName } from "@/mocks/films";

interface FilmCardProps {
  film: Film;
  showSummary?: boolean;
}

export default function FilmCard({ film, showSummary = true }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-all duration-300 hover:border-accent-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 影片海报`}
          title={`${film.title} · 欧美成人电影`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/80 to-transparent" />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded text-[11px] font-medium bg-primary-950/70 text-background-100 backdrop-blur-sm">
          {film.year}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded text-[11px] font-semibold bg-accent-500 text-primary-950 flex items-center gap-1">
          <i className="ri-star-fill text-[10px]" />
          {film.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-2.5 left-2.5 flex items-center gap-1.5 text-[11px] text-background-100">
          <i className="ri-map-pin-line text-[11px]" />
          {film.region}
          <span className="mx-1 text-background-400">·</span>
          {film.duration} 分钟
        </div>
      </div>

      <div className="p-3.5 flex flex-col flex-1">
        <h3 className="font-heading text-[15px] font-semibold text-foreground-950 leading-snug group-hover:text-accent-700 transition-colors line-clamp-1">
          {film.title}
        </h3>
        <p className="mt-1 text-[11px] tracking-wide text-foreground-400 uppercase line-clamp-1">
          {film.titleEn}
        </p>
        {showSummary && (
          <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
            {film.summary}
          </p>
        )}
        <div className="mt-3 pt-2.5 border-t border-background-200/80 flex items-center gap-1.5 flex-wrap">
          {film.categories.slice(0, 2).map((slug) => (
            <span
              key={slug}
              className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800"
            >
              {getCategoryName(slug)}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400 ml-auto whitespace-nowrap">
            主演 {film.cast[0]}
          </span>
        </div>
      </div>
    </Link>
  );
}